export default "__VITE_ASSET__YQ_L4c07__"